var map = {
	"./RGB_IBC.svg": 63024,
	"./RGB_ICCPC.svg": 99334,
	"./RGB_IEBC.svg": 75358,
	"./RGB_IECC.svg": 40849,
	"./RGB_IFC.svg": 97990,
	"./RGB_IFGC.svg": 82089,
	"./RGB_IMC.svg": 41812,
	"./RGB_IPC.svg": 67397,
	"./RGB_IPMC.svg": 44165,
	"./RGB_IPSDC.svg": 59589,
	"./RGB_IRC.svg": 63662,
	"./RGB_ISPSC.svg": 29731,
	"./RGB_IWUIC.svg": 29665,
	"./RGB_IZC.svg": 35273,
	"./RGB_IgCC.svg": 14532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79768;